import { useEffect, useState } from 'react';
import { cheerJamboree as defaultCheer } from '../mock';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Fetches the admin-editable Cheer Jamboree from the API on mount.
 * Falls back to bundled defaults (mock.js) if the API is unreachable
 * or hasn't been seeded yet.
 */
export const useCheerEvent = () => {
  const [event, setEvent] = useState(defaultCheer);
  const [loaded, setLoaded] = useState(false);

  const fetchEvent = async () => {
    try {
      const res = await fetch(`${API_URL}/api/event/cheer`);
      if (!res.ok) throw new Error(`status ${res.status}`);
      const data = await res.json();
      if (data && data.event) {
        setEvent({ ...defaultCheer, ...data.event });
      }
    } catch {
      /* silently fall back to bundled defaults */
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    fetchEvent();
  }, []);

  return { event, loaded, refresh: fetchEvent };
};

export default useCheerEvent;
